import type { ExerciseTemplate } from './exercise-template'

export interface ExerciseCategory {
  id: string
  name: string
  position: number
}

export const EXERCISE_EQUIPMENTS = [
  'fingerboard',
  'campus',
  'board',
  'wall',
  'gym',
  'none',
] as const

export type ExerciseEquipment = (typeof EXERCISE_EQUIPMENTS)[number]

export interface Exercise {
  id: string
  title: string
  description: string | null
  duration_minutes: number | null
  image_url: string | null
  /** Groups the variants of one protocol under a single catalog card. */
  family: string | null
  /** What tells this variant apart inside its family, e.g. '90%'. */
  variant_label: string | null
  equipment: ExerciseEquipment | null
  /** False for the shared catalog, true for someone's private exercise. */
  custom?: boolean
  /** Whether the current user owns it, and may therefore edit or delete it. */
  owned?: boolean
  category: ExerciseCategory
  templates?: ExerciseTemplate[]
}
